import { z } from "zod";
import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";
import { queryKeys } from "utils/misc";

export const activitySchema = z.object({
  user_activity_id: z.number().nullable().optional(),
  user_activity_schedule_id: z.number().nullable().optional(),
  patient_id: z.number(),
  start_date: z.string(),
  completed_on: z.string().nullable().optional(),
  completed: z.boolean(),
  type: z.string(),
  start_day: z.number().nullable().optional(),
  course_week_number: z.number(),
  required: z.boolean(),
  specific_joint_pain: z.number().nullable().optional(),
  repetitions: z.number().nullable().optional(),
});

export type Activity = z.infer<typeof activitySchema>;

const scheduleResponseSchema = z.object({
  current: z.array(activitySchema),
});

export const useSchedule = (week: number) => {
  const patientId = useId();
  const key = queryKeys.schedule(patientId, week);

  return useQuery(
    key,
    async () => {
      const data = await api.parse(`GET /patients/{patient_id}/schedule/weeks/{week_number}` as any, {
        params: [patientId, week],
        root: supportApiBase,
      });
      return scheduleResponseSchema.parse(data);
    },
    { keepPreviousData: true, enabled: !!key }
  );
};
